import React, {useState, useEffect} from 'react';
import {Modal, Button, Loader, ButtonToolbar} from 'rsuite';
import SingleBed from './SingleBed';
import _ from 'lodash';
import useRequestHandler from "hooks/useRequestHandler";

const bedsMaxAmount = 10;

const AddBedManually = (props) => {

    const {auth, facilityId, modalOpen, setModalOpen, refreshData} = props;

    const [showBin, setShowBin] = useState(false);
    const [addBedBtnDisabled, SetAddBedBtnDisabled] = useState(false);
    const [saveBeds, SetSaveBeds] = useState(false);

    const [bedsToAdd, setBedsToAdd] = useState([SingleBed]);
    const [actualBedsCount, setActualBedsCount] = useState(1);
    const [bedsData, setBedsData] = useState([]);

    const [sections, setSections] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [loaderContent, setLoaderContent] = useState('');
    const getSectionsRequest = useRequestHandler({
        auth,
        apiArguments: [facilityId],
        apiName: 'getSectionsNames',
        successMessageData: {show: false},
        errorMessageData: {
            title: 'Warning',
            message: 'Unable to load sections, just add a new one.',
            type: 'info'
        }
    })
    const getSections = async () => {
        setLoaderContent('Loading sections');
        setIsLoading(true);
        await getSectionsRequest(data => setSections(data.map(item => ({ label: item, value: item }))))
        setIsLoading(false);
    }

    const saveBedsRequest = useRequestHandler({
        auth,
        apiArguments: [facilityId],
        apiName: 'createBed',
        successMessageData: {
            message: 'Beds are successfully added.',
            duration: 3000
        },
        errorMessageData: {
            title: 'Warning',
            message: 'Unable to load sections, just add a new one.',
            type: 'info'
        }
    })

    const sendRequest = async () => {
        const bedsToSend = bedsData.filter(item => !!item);
        setLoaderContent('Saving bed(s)');
        setIsLoading(true);
        const onSuccess = async () => {
            setBedsToAdd([SingleBed])
            setActualBedsCount(1);
            setBedsData([]);
            SetSaveBeds(false);
            await refreshData();
            setModalOpen(false)
        }
        await saveBedsRequest(onSuccess, null, [bedsToSend]);
        setIsLoading(false);
    }

    const addBed = () => {
        const localBedsToAdd = _.cloneDeep(bedsToAdd);
        localBedsToAdd.push(SingleBed);
        setBedsToAdd(localBedsToAdd);
        setActualBedsCount(actualBedsCount + 1);
    }

    const removeBed = (bedIndex) => {
        const beds = _.cloneDeep(bedsToAdd);
        delete beds[bedIndex]
        setBedsToAdd(beds);
        setActualBedsCount(actualBedsCount - 1);

        if(!bedsData[bedIndex]) return;
        const localBedsData = _.cloneDeep(bedsData)
        localBedsData.splice(bedIndex, 1);
        setBedsData(localBedsData);
    }

    const submitBeds = () => SetSaveBeds(true);

    useEffect(() => {
        if(actualBedsCount >= bedsMaxAmount && !addBedBtnDisabled) SetAddBedBtnDisabled(true)
        if(actualBedsCount < bedsMaxAmount && addBedBtnDisabled) SetAddBedBtnDisabled(false)

        if(actualBedsCount >= 2 && !showBin) setShowBin(true)
        if(actualBedsCount === 1 && showBin) setShowBin(false)
    }, [bedsToAdd])

    const getDataFromBedForm = (formIndex, values) => {
        const localBedsData = _.cloneDeep(bedsData);
        localBedsData[formIndex] = values;
        setBedsData(localBedsData);
    }

    useEffect(() => {
        if(actualBedsCount === bedsData.filter(item => !!item).length) {
            sendRequest();
        }
    }, [bedsData])

    const cancelAddingBeds = () => {
        setBedsToAdd([SingleBed])
        setActualBedsCount(1);
        setBedsData([]);
        SetSaveBeds(false);
        setModalOpen(false);
    }

    return (
        <Modal
            size='md'
            onOpen={getSections}
            open={modalOpen}
            className='add-bed-manually-modal'
            onClose={cancelAddingBeds}
        >
            <Modal.Header>
                <Modal.Title><strong>Add Beds</strong></Modal.Title>
            </Modal.Header>
            {isLoading &&
                <div className='loader-wrapper'>
                    <Loader size='lg' center content={loaderContent}/>
                </div> }
                <Modal.Body className={isLoading ? 'hidden' : ''}>
                    <div className='beds-list'>
                        {bedsToAdd.map((SingleBed, index) => (
                            SingleBed && <SingleBed
                                showBin={showBin}
                                getData={getDataFromBedForm}
                                onRemove={removeBed}
                                index={index}
                                key={index}
                                formSubmit={saveBeds}
                                setFormSubmit={SetSaveBeds}
                                sections={sections}
                                setSections={setSections}
                            />
                        ))}
                    </div>
                    <div className='add-bed-btn-wrapper'>
                        <Button
                            block
                            appearance="ghost"
                            onClick={addBed}
                            disabled={addBedBtnDisabled}
                        >ADD BED</Button>
                    </div>
                </Modal.Body>
                <Modal.Footer className={isLoading ? 'hidden' : ''}>
                    <ButtonToolbar>
                        <Button  appearance="ghost" size='lg' className="add-bed-btn btn-cancel" onClick={cancelAddingBeds} >Cancel</Button>
                        <Button  appearance="primary" size='lg' className="add-bed-btn btn-save" onClick={submitBeds} >Save</Button>
                    </ButtonToolbar>
                </Modal.Footer>
        </Modal>
    );
};

AddBedManually.defaultProps = {
    modalOpen: true,
    setModalOpen: () => {},
    refreshData: () => {}
}

export default AddBedManually;